import { RepareoFunnel } from "@App/Pages";
import { Route, Routes } from "react-router-dom";
import "@App/utils/analytics/mappings";
import { partnerRoutes } from "@App/routes/partners";
import { useGaragePropertyContext } from "@App/hooks/contexts/useGaragePropertyContext";
import { GaragePropertyContext } from "@App/contexts/listing/GaragePropertyContext";

export function App() {
  const garagePropertiesContext = useGaragePropertyContext();

  return (
    <GaragePropertyContext.Provider value={garagePropertiesContext}>
      <Routes>
        {partnerRoutes.map(([path, Component]) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {/* Catch-all */}
        <Route path="/*" element={<RepareoFunnel />} />
      </Routes>
    </GaragePropertyContext.Provider>
  );
}
